<template>
  <v-app>
    <v-container fluid>
      <v-row><v-col cols="12">
          <v-expansion-panels v-model="panel"><v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search
                Form</v-expansion-panel-title>
              <v-expansion-panel-text><v-form @submit.prevent="submit"><v-row class="pa-2">
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete v-model="warehouse_id.value.value" label="Warehouse" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getWarehouseList" item-title="name" item-value="id"
                        clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-autocomplete v-model="product_id.value.value" label="Product" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" item-value="id" clearable hide-details
                        class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete v-model="category_id.value.value" label="Category" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getCategoryList" item-title="name" item-value="id"
                        clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-select v-model="source_type.value.value" label="Source Type" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="sourceTypes" item-title="title" item-value="value"
                        clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="from_date.value.value" label="From Date"
                        bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month"
                        variant="outlined" density="compact" clearable hide-details class="py-1" />
                      <v-btn class="bg-brand my-1" type="submit" :loading="loading">Search</v-btn>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="to_date.value.value" label="To Date"
                        bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month"
                        variant="outlined" density="compact" clearable hide-details class="py-1" />
                    </v-col>
                  </v-row></v-form></v-expansion-panel-text>
            </v-expansion-panel></v-expansion-panels>
        </v-col></v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;"><v-row><v-col cols="12">
          <v-expansion-panels v-model="panel"><v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item Received
                Report</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2"><v-col md="4" cols="12"><v-text-field v-model="search"
                      append-inner-icon="mdi-magnify" label="Search" hide-details density="compact" variant="outlined"
                      clearable /></v-col>
                  <v-col md="4" cols="12" class="d-flex justify-center"><v-btn-group variant="outlined"
                      density="compact" size="x-small" divided>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                        @click="exportToCSV">CSV</v-btn>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                        @click="exportToExcel">EXCEL</v-btn>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                    </v-btn-group></v-col></v-row>
                <v-data-table :headers="reportHeaders" :items="reports?.data || []" :loading="loading"
                  v-model:items-per-page="itemsPerPage" :search="search" hover density="compact">
                  <template #item.unit_cost="{ item }">{{ formatNumber(item.unit_cost) }}</template>
                  <template #item.total_value="{ item }">{{ formatNumber(item.total_value) }}</template>
                  <template #body.append>
                    <tr class="font-weight-bold bg-grey-lighten-4">
                      <td v-for="header in reportHeaders" :key="header.key" class="text-end px-1">{{ header.key === "sl" ?
                        "Total" : reports?.summary?.[header.key] ?? "" }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel></v-expansion-panels>
        </v-col></v-row></v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter.js";

export default {
  data: () => ({
    itemsPerPage: 10, panel: [0], search: "",
    sourceTypes: [
      { title: "Purchase Order", value: "po" }, { title: "LC Receive", value: "lc" },
      { title: "Direct Receive", value: "dr" }, { title: "Production", value: "production" },
      { title: "Sales Return", value: "sales_return" }, { title: "Warehouse Transfer", value: "transfer" },
    ],
    headers: [
      { title: "SL", key: "sl", align: "center", sortable: false },
      { title: "Receive No.", key: "receive_no", align: "left", sortable: false },
      { title: "Receive Date", key: "receive_date", align: "left", sortable: false },
      { title: "Original Reference No.", key: "original_reference_no", align: "left", sortable: false },
      { title: "GRN No.", key: "grn_no", align: "left", sortable: false },
      { title: "Supplier/Source", key: "supplier_source", align: "left", sortable: false },
      { title: "Challan No.", key: "challan_no", align: "left", sortable: false },
      { title: "Invoice No.", key: "invoice_no", align: "left", sortable: false },
      { title: "Item Code", key: "item_code", align: "left", sortable: false },
      { title: "Item Name", key: "item_name", align: "left", sortable: false },
      { title: "Category", key: "category", align: "left", sortable: false },
      { title: "Batch/Lot No.", key: "batch_lot_no", align: "left", sortable: false },
      { title: "UOM", key: "uom", align: "left", sortable: false },
      { title: "Ordered Qty.", key: "ordered_qty", align: "end", sortable: false },
      { title: "Received Qty.", key: "received_qty", align: "end", sortable: false },
      { title: "Accepted Qty.", key: "accepted_qty", align: "end", sortable: false },
      { title: "Rejected Qty.", key: "rejected_qty", align: "end", sortable: false },
      { title: "Free Qty.", key: "free_qty", align: "end", sortable: false },
      { title: "Unit Cost", key: "unit_cost", align: "end", sortable: false },
      { title: "Total Value", key: "total_value", align: "end", sortable: false },
      { title: "Manufacturing Date", key: "manufacturing_date", align: "left", sortable: false },
      { title: "Expiry Date", key: "expiry_date", align: "left", sortable: false },
      { title: "Warehouse", key: "warehouse", align: "left", sortable: false },
      { title: "Rack/Location", key: "rack_location", align: "left", sortable: false },
      { title: "Quality Status", key: "quality_status", align: "left", sortable: false },
      { title: "Received By", key: "received_by", align: "left", sortable: false },
      { title: "Checked By", key: "checked_by", align: "left", sortable: false },
      { title: "Approved By", key: "approved_by", align: "left", sortable: false },
      { title: "Status", key: "status", align: "left", sortable: false },
      { title: "Remarks", key: "remarks", align: "left", sortable: false },
    ],
  }),
  computed: {
    reportHeaders() {
      const columns = this.reports?.columns;
      if (!Array.isArray(columns) || !columns.length) return this.headers;
      return columns.map(({ field, label }) => ({ title: label, key: field, align: field === "sl" ? "center" : "start", sortable: false }));
    },
    getWarehouseList() { return this.$store.getters.getWarehouseList; },
    getCategoryList() { return (this.$store.getters.getCategoryList || []).filter((item) => item.status == 1); },
    getProductMapList() { return (this.$store.getters.getProductMapList || []).filter((item) => item.branch_id == this.$store.getters.getAuthUser.branch_id && item.status == 1); },
  },
  created() {
    // if (this.$store.getters.getCategoryList.length === 0)
    this.$store.dispatch("getCategoryList");
    // if (this.$store.getters.getWarehouseList.length === 0)
    this.$store.dispatch("getWarehouseList");
    // if (this.$store.getters.getProductMapList.length === 0)
    this.$store.dispatch("getProductMapList");
  },
  setup() {
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });
    const warehouse_id = useField("warehouse_id"), product_id = useField("product_id");
    const category_id = useField("category_id"), source_type = useField("source_type");
    const from_date = useField("from_date"), to_date = useField("to_date");
    const store = useStore();
    const loading = ref(false), reports = ref({});
    const submit = handleSubmit((values) => {
      loading.value = true;

      const params = {
        ...values,
        from_date: formattedDate(values.from_date),
        to_date: formattedDate(values.to_date),
      };
      store.dispatch("getInvItemReceivedReport", params)
        .then((response) => { reports.value = response.data; })
        .catch((error) => toast.error(error.response?.data?.message || "Unable to load report"))
        .finally(() => { loading.value = false; });
    });
    return { warehouse_id, product_id, category_id, source_type, from_date, to_date, loading, reports, submit };
  },
  methods: {
    formatNumber(value) { return value == null ? "" : Number(value).toFixed(2); },
    exportRows() { return [this.reportHeaders.map((header) => header.title), ...(this.reports?.data || []).map((item) => this.reportHeaders.map((header) => item[header.key] ?? ""))]; },
    exportToCSV() { this.$exportTableToCSV(this.exportRows(), `item_received_report_${this.$fileDate()}`); },
    exportToExcel() { this.$exportTableToExcel(this.exportRows(), `item_received_report_${this.$fileDate()}`); },
    exportToPDF() { this.$exportTableToPDF(this.reportHeaders.map((header) => header.title), (this.reports?.data || []).map((item) => this.reportHeaders.map((header) => item[header.key] ?? "")), "Item Received Report", `item_received_report_${this.$fileDate()}`); },
  },
  mounted() {
    const date = new Date();
    const futureDate = new Date();

    futureDate.setDate(date.getDate() + 30);

    this.from_date.value.value = date;
    this.to_date.value.value = futureDate;
  }
};
</script>